import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft, Map, ChevronRight } from "lucide-react";
import { api, initials, avatarColor, STATUS_META } from "@/lib/api";

export default function RegionDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [region, setRegion] = useState(null);
  const [employees, setEmployees] = useState([]);

  useEffect(() => {
    api.get("/regions").then((r) => setRegion(r.data.find((x) => x.id === id)));
    api.get("/employees", { params: { region_id: id } }).then((r) => setEmployees(r.data));
  }, [id]);

  return (
    <div className="space-y-6">
      <button onClick={() => navigate("/regions")} className="flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-900">
        <ArrowLeft className="h-4 w-4" /> Back to Regions
      </button>

      <div className="flex items-center gap-4 rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
        <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-slate-900 text-white"><Map className="h-6 w-6" /></div>
        <div>
          <h1 className="font-heading text-2xl font-extrabold text-slate-900">{region?.name || "Region"}</h1>
          <p className="text-sm text-slate-500">Region {region?.number} · {employees.length} employee{employees.length !== 1 ? "s" : ""}</p>
        </div>
      </div>

      <div className="overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
        {employees.length === 0 && <p className="p-6 text-sm text-slate-400">No employees in this region yet.</p>}
        {employees.map((e) => {
          const m = STATUS_META[e.employment_status] || STATUS_META.other;
          return (
            <button key={e.id} data-testid="region-employee-row" onClick={() => navigate(`/people/${e.id}`)}
              className="flex w-full items-center gap-3 border-b border-slate-100 px-5 py-3 text-left last:border-0 hover:bg-slate-50">
              <div className={`flex h-9 w-9 items-center justify-center rounded-full text-xs font-bold ${avatarColor(e.full_name)}`}>{initials(e.full_name)}</div>
              <div className="min-w-0 flex-1">
                <p className="font-medium text-slate-900">{e.full_name}</p>
                <p className="text-xs text-slate-500">{e.job_role} · RCSM: {e.rcsm_name || "—"}</p>
              </div>
              <span className={`rounded-full border px-2 py-0.5 text-xs font-medium ${m.cls}`}>{m.label}</span>
              <ChevronRight className="h-4 w-4 text-slate-300" />
            </button>
          );
        })}
      </div>
    </div>
  );
}
